(function (window, angular, undefined) {
    angular.module('formApp')
        .service('sessionService', ['FormService', '$rootScope', 'SESSION_TIMEOUT', function (formService, $rootScope, sessionTimeout) {

            var delta,
                time = parseInt(sessionTimeout, 10), // - 1200000 - 20minutes
                quarterTime = time / 4,
                count = 0,
                pulse,
                session,
                stopped = false,
                tempTime,
                timeoutTime,
                warningTime;

            function listener() {
                timeoutTime = Date.now() + time;
                warningTime = timeoutTime - quarterTime;

                delta = 1000;
                session = setInterval( // 20 Minutes
                    
                    function () {
                        tempTime = Date.now();
                        // console.log('warningTime - tempTime: ', warningTime - tempTime);
                        // console.log('timeoutTime - tempTime: ', timeoutTime - tempTime);

                        if (tempTime >= warningTime) { // 300000 = 5 minutes from TIMEOUT
                            $rootScope.$broadcast('TIMEOUT.WARNING');
                        }
                        
                        if (tempTime >= timeoutTime) {
                            sessionStorage.removeItem('currentRefreshState');
                            sessionStorage.removeItem('formStateUri');
                            sessionStorage.removeItem('campaign');
                            sessionStorage.removeItem('brav');
                            sessionStorage.removeItem('hideDiscount');
                            $rootScope.$broadcast('TIMEOUT.EMAIL');
                            clearInterval(session);
                            clearInterval(pulse);
                        }
                    }, delta
                );   
            }

            function init() {
                var events = [
                    "keyup",
                    "keypress",
                    "blur",
                    "change",
                    "mousemove",
                    "touchstart"
                ];
                for (var i = 0; i < events.length; i++) {
                    document.addEventListener(events[i], function () {
                        clearInterval(session);
                        if (!stopped) {
                            listener();
                        }
                    });
                }
                start();
            }

            function refresh() {
                if (time > 0) {
                    formService.init();
                    clearInterval(session);
                    listener();
                }
            }

            function restart() {
                clearInterval(session);
                window.location.reload();
            }

            function stop() {
                clearInterval(session);
                stopped = true;
            }

            function start() {
                stopped = false;
                clearInterval(session);
                listener();
            }


            function heartbeat() {
                formService.heartbeat();
                clearInterval(pulse);
                pulse = setInterval(function() {
                    formService.heartbeat();   
                }, 60000);
            }

            return  {
                init: init,
                heartbeat: heartbeat,
                refresh: refresh,
                restart: restart,
                stop: stop,
                start: start
            };

        }]);  
})(window, window.angular);